import { render } from "./WallAlertSolutionTab.vue?vue&type=template&id=039071e1&scoped=true"
import script from "./WallAlertSolutionTab.vue?vue&type=script&lang=js"
export * from "./WallAlertSolutionTab.vue?vue&type=script&lang=js"

import "./WallAlertSolutionTab.vue?vue&type=style&index=0&id=039071e1&scoped=true&lang=css"
import "./WallAlertSolutionTab.vue?vue&type=style&index=1&id=039071e1&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039071e1"]])

export default __exports__